import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Row, Col, Form, FloatingLabel, Button } from "react-bootstrap";
import PageLayout from "../../../layouts/PageLayout";
import "react-form-wizard-component/dist/style.css";

export default function AddVocationalTraining() {

  const tabChanged = ({ prevIndex, nextIndex }) => {
    if (nextIndex !== prevIndex) {
      window.scrollTo({
        top: 0,
        behavior: "smooth", // Adds a smooth scrolling effect
      });
    }
    console.log("prevIndex", prevIndex);
    console.log("nextIndex", nextIndex);
  };

  const [values, setValues] = useState({
    selectFamily: "",
    selectChildren: "",
    instituteName: "",
    trainingName: "",
    trainingDuration: "",
    totalFees: "",
    selectStatus: "",
    trainingImages: null,



  });

  const handleChange = (e) => {
    const { name, value, type, files } = e.target;
    if (type === 'file') {
      setValues((prevState) => ({
        ...prevState,
        [name]: Array.from(files),
      }));
    } else {
      setValues((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    }

  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log(values)
  };

  return (

    <PageLayout>
      <Row>
        <Col xl={12}>
          <div className="mc-card">
            <div className='mc-breadcrumb'>
              <h3 className="mc-breadcrumb-title">{'Create Training'}</h3>
              <ul className="mc-breadcrumb-list">
                <li className="mc-breadcrumb-item"><Link to='#' className="mc-breadcrumb-link">{'home'}</Link></li>
                <li className="mc-breadcrumb-item"><Link to='#' className="mc-breadcrumb-link">{'Vocational Training'}</Link></li>
                <li className="mc-breadcrumb-item">{'Create New Training'}</li>
              </ul>
            </div>
          </div>
        </Col>
      </Row>





      <div className="card">
        <div className="card-header">
          Create Training
        </div>
        <div className="card-body">
          <form onSubmit={handleSubmit}>
            <Row>
              <Form.Group as={Col} md="4" controlId="validationCustom01">
                <FloatingLabel
                  controlId="floatingTextarea"
                  label="Select Family"
                  className="mb-3"
                >
                  <Form.Select
                    required
                    type="text"
                    name="selectFamily"
                    placeholder=""
                    value={values.selectFamily}
                    onChange={handleChange}
                  >
                    <option>Select...</option>
                    <option>FSF 1</option>
                    <option>FSF 2</option>
                  </Form.Select>
                </FloatingLabel>
              </Form.Group>
              <Form.Group as={Col} md="4" controlId="validationCustom01">
                <FloatingLabel
                  controlId="floatingSelect"
                  label="Select Children"
                  className="mb-3"
                >
                  <Form.Select
                    required
                    type="text"
                    name="selectChildren"
                    placeholder=""
                    value={values.selectChildren}
                    onChange={handleChange}
                  >
                    <option>Select...</option>
                    <option>Child 1</option>
                    <option>Child 2</option>
                  </Form.Select>
                </FloatingLabel>
              </Form.Group>
              <Form.Group as={Col} md="4" controlId="validationCustom01">
                <FloatingLabel
                  controlId="floatingInputGrid" label="Enter Institute's Name" className="mb-3">
                  <Form.Control
                    required
                    type="text"
                    name="instituteName"
                    placeholder=""
                    value={values.instituteName}
                    onChange={handleChange}
                  />
                </FloatingLabel>
              </Form.Group>
              <Form.Group as={Col} md="4" controlId="validationCustom01">
                <FloatingLabel
                  controlId="floatingTextarea"
                  label="Training Name"
                  className="mb-3"
                >
                  <Form.Control
                    required
                    type="text"
                    name="trainingName"
                    placeholder=""
                    value={values.trainingName}
                    onChange={handleChange}
                  />
                </FloatingLabel>
              </Form.Group>
              <Form.Group as={Col} md="4" controlId="validationCustom01">
                <FloatingLabel
                  controlId="floatingTextarea"
                  label="Training Duration"
                  className="mb-3"
                >
                  <Form.Control
                    required
                    type="text"
                    name="trainingDuration"
                    placeholder=""
                    value={values.trainingDuration}
                    onChange={handleChange}
                  />
                </FloatingLabel>
              </Form.Group>
              <Form.Group as={Col} md="4" controlId="validationCustom01">
                <FloatingLabel
                  controlId="floatingTextarea"
                  label="Total Fees"
                  className="mb-3"
                >
                  <Form.Control
                    required
                    type="text"
                    name="totalFees"
                    placeholder=""
                    value={values.totalFees}
                    onChange={handleChange}
                  />
                </FloatingLabel>
              </Form.Group>
              <Form.Group as={Col} md="4" controlId="validationCustom01">
                <FloatingLabel
                  controlId="floatingTextarea"
                  label="Select Status"
                  className="mb-3"
                >
                  <Form.Select
                    required
                    type="text"
                    name="selectStatus"
                    placeholder=""
                    value={values.selectStatus}
                    onChange={handleChange}
                  >
                    <option>Select...</option>
                    <option>In Progress</option>
                    <option>Completed</option>
                  </Form.Select>
                </FloatingLabel>
              </Form.Group>
              <Form.Group controlId="formFileMultiple">
                <FloatingLabel>
                  <FloatingLabel
                    label="Training Images">
                    <Form.Control
                      required
                      multiple
                      name="trainingImages"
                      onChange={handleChange}
                      type="file"
                      placeholder="Training Iamges"
                      style={{ height: '60px' }} />
                  </FloatingLabel>
                </FloatingLabel>
              </Form.Group>
            </Row>
            <Button className="py-2 my-3" variant="success" type="submit">
              Create Training
            </Button>
          </form>
        </div>

      </div>




    </PageLayout>
  );
}
